import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { catchError, Observable, of, tap } from 'rxjs';
import posthog from 'posthog-js';
import { UserService } from '../core/services/user.service';
import { UserInfo } from '../core/models/user-info.model';
import { environment } from '../../environments/environment';

export type UserState = {
  userInfo: UserInfo | null;
};

const initialState: UserState = {
  userInfo: null
};

export const UserStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store, userService = inject(UserService)) => ({
    loadUserInfo(): Observable<UserInfo | null> {
      return userService.getUserInfo().pipe(
        tap((userInfo) => {
          patchState(store, { userInfo });
          this.initializeAnalytics(userInfo);
        }),
        catchError((err) => {
          console.error('Failed to fetch user info', err);
          return of(null);
        })
      );
    },
    initializeAnalytics(userInfo: UserInfo): void {
      const email = userInfo.contact?.email;
      const userName = `${userInfo.contact?.first_name ?? ''} ${userInfo.contact?.last_name ?? ''}`.trim();

      if (email && window.pendo) {
        window.pendo.initialize({
          visitor: {
            id: email,
            email: email,
            user_name: userName
          },
          account: {
            id: String(userInfo.company?.id),
            name: userInfo.company?.name
          }
        });
      }

      if (email && environment.POSTHOG?.KEY) {
        posthog.identify(email, {
          email: email,
          name: userName,
          companyId: userInfo.company?.id,
          companyName: userInfo.company?.name,
        });
      }
    }
  }))
);
